import { apiGet, apiPost } from './client';
import { PRODUCT_WIKI_SLUG } from './projects';

export interface TocEntry {
  name: string;
  path: string;
  type: 'file' | 'folder';
  children: TocEntry[];
}

export interface TocResponse {
  wiki: TocEntry[];
  raw: TocEntry[];
}

export interface TocRefreshResponse {
  refreshed: boolean;
}

export function getToc(): Promise<TocResponse> {
  return apiGet<TocResponse>(`/${PRODUCT_WIKI_SLUG}/toc`);
}

export function refreshToc(): Promise<TocRefreshResponse> {
  return apiPost<TocRefreshResponse>(`/${PRODUCT_WIKI_SLUG}/toc/refresh`, {});
}
